// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CollegePlayerCard_cardContainer__25v4X","socialCardVariant":"CollegePlayerCard_socialCardVariant__wyktv"};